import Http from '@/services/http';

export default {

  saveSecretQuestion({ pergunta, resposta }) {
    const http = new Http();
    return http.post('/PerguntaSecreta', { pergunta, resposta });
  },
};
